import { render, staticRenderFns } from "./RsaGestioneCamereListPage.vue?vue&type=template&id=08f8e5fe"
import script from "./RsaGestioneCamereListPage.vue?vue&type=script&lang=js"
export * from "./RsaGestioneCamereListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports